import React from 'react';
import Layout from './layout';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
    const { t } = useTranslation();

    return (
        <Layout selected="privacy">
            <div className="container min-vh-100">
                <h1>{t('privacy-title')}</h1>
                <div>
                    {t('privacy-text').split('\n').map((line, index) => (
                        <React.Fragment key={`${line}-${index}`}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </Layout>
    );
}

export default Privacy;
